// src/store/modules/authController.js
import axios from '@/api/axios'
import { MAIN_API } from '@/api/apiUrl'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        async getCarBrandList() {
            const response = await axios.get(`${MAIN_API}/api/car-brand`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async createCarBrand(_, data) {
            const response = await axios.post(`${MAIN_API}/api/car-brand/create`, data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            return response.data
        },
        async deleteCarBrand(_, id) {
            const response = await axios.delete(`${MAIN_API}/api/car-brand/delete/${id}`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async updateCarBrand(_, data) {
            const response = await axios.put(`${MAIN_API}/api/car-brand/update/${data.id}`, data, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getCarModelListByBrandId(_, brandId) {
            const response = await axios.get(`${MAIN_API}/api/car-model/brand/${brandId}`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getCarModelList() {
            const response = await axios.get(`${MAIN_API}/api/car-model`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async createCarModel(_, data) {
            const response = await axios.post(`${MAIN_API}/api/car-model/create`, data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            return response.data
        },
        async deleteCarModel(_, id) {
            const response = await axios.delete(`${MAIN_API}/api/car-model/delete/${id}`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async updateCarModel(_, data) {
            const response = await axios.put(`${MAIN_API}/api/car-model/update/${data.id}`, data, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
    },
    getters: {
    }
}
